import autoComplete from "@tarekraafat/autocomplete.js";

/**
 * Hook into Alpine so that it is available no matter at which point Alpine loads.
 */
document.addEventListener('alpine:init', () => {

    Alpine.data('autoComplete', (id, inputAttributeName, autocompleteAttributes) => ({
        /**
         * @var string identifier attribute for this autocomplete input
         */
        id: id,

        /**
         * @var object reference to the autocomplete library instance
         */
        autoCompleteJS: null,

        /**
         * @var string the name of input attribute used for autocomplete
         */
        inputAttributeName: inputAttributeName,

        /**
         * @var array list of inputs for autocomplete
         */
        autocompleteAttributes: autocompleteAttributes,

        /**
         * @var bool autocomplete loading status.
         */
        loading: false,

        /**
         * The minimum length of input to be autocompleted.
         */
        AUTOCOMPLETE_MIN_LENGTH: 5,

        /**
         * Initialize the input.
         *
         * @return void
         */
        construct() {
            if (!this.$wire.lookupEnabled) {
                return;
            }
            this.autoCompleteJS = this.initAutoComplete();
        },

        init() {
            if (!this.$wire.lookupEnabled) {
                return;
            }
            Livewire.on(`address-lookup-processed-${this.inputAttributeName}`, () => this.refreshAutocomplete());
        },

        refreshAutocomplete() {
            this.autoCompleteJS.start();
            this.autoCompleteJS.input.focus();
            this.loading = false;
        },

        /**
         * Initialize the autocomplete plugin.
         *
         * @return object
         */
        initAutoComplete() {
            const that = this;

            const config = {
                selector: `#${this.id}`, // Any valid selector
                wrapper: false,
                data: {
                    src: async () => this.$wire.addressAutocomplete,
                    keys: ['address']
                },
                resultItem: {
                    highlight: true,
                    element: (item, data) => {
                        item.innerHTML = `<span>
                            ${data.match}, ${data.value.stateOrProvince} ${data.value.postalCode}
                        </span>`;
                    },
                },
                debounce: 150,
                events: {
                    input: {
                        input(event) {
                            if (event.target.value && event.target.value.length >= that.AUTOCOMPLETE_MIN_LENGTH) {
                                that.loading = true;
                            }
                        },
                        selection(event) {
                            const feedback = event.detail;
                            autoCompleteJS.input.blur();
                            const selection = feedback.selection.value;
                            that.$wire.set(that.inputAttributeName, selection.address);
                            if (feedback.selection.value && that.autocompleteAttributes) {
                                that.$wire.fillAutocompleteAttributes(feedback.selection.value, that.autocompleteAttributes);
                            }
                        },
                    },
                },
            };
            const autoCompleteJS = new autoComplete(config);

            return autoCompleteJS;
        }
    }));
});